export default __webpack_public_path__ + "static/media/sermon.3e6972b9.jpg";